// src/core-events/index.ts
var R = /* @__PURE__ */ ((E) => (E.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", E.CHANNEL_CREATED = "channelCreated", E.CONFIG_ERROR = "co\
nfigError", E.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", E.STORY_SPECIFIED = "storySpecified", E.SET_CONFIG = "setConfig", E.SET_STORIES =
"setStories", E.SET_INDEX = "setIndex", E.SET_CURRENT_STORY = "setCurrentStory", E.CURRENT_STORY_WAS_SET = "currentStoryWasSet", E.FORCE_RE_RENDER =
"forceReRender", E.FORCE_REMOUNT = "forceRemount", E.PRELOAD_ENTRIES = "preloadStories", E.STORY_PREPARED = "storyPrepared", E.DOCS_PREPARED =
"docsPrepared", E.STORY_CHANGED = "storyChanged", E.STORY_UNCHANGED = "storyUnchanged", E.STORY_RENDERED = "storyRendered", E.STORY_MISSING =
"storyMissing", E.STORY_ERRORED = "storyErrored", E.STORY_THREW_EXCEPTION = "storyThrewException", E.STORY_RENDER_PHASE_CHANGED = "storyRend\
erPhaseChanged", E.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", E.UNHANDLED_ERRORS_WHILE_PLAYING = "unhandledErrorsWhilePla\
ying", E.UPDATE_STORY_ARGS = "updateStoryArgs", E.STORY_ARGS_UPDATED = "storyArgsUpdated", E.RESET_STORY_ARGS = "resetStoryArgs", E.SET_GLOBALS =
"setGlobals", E.UPDATE_GLOBALS = "updateGlobals", E.GLOBALS_UPDATED = "globalsUpdated", E.REGISTER_SUBSCRIPTION = "registerSubscription", E.
PREVIEW_KEYDOWN = "previewKeydown", E.PREVIEW_BUILDER_PROGRESS = "preview_builder_progress", E.SELECT_STORY = "selectStory", E.STORIES_COLLAPSE_ALL =
"storiesCollapseAll", E.STORIES_EXPAND_ALL = "storiesExpandAll", E.DOCS_RENDERED = "docsRendered", E.SHARED_STATE_CHANGED = "sharedStateChan\
ged", E.SHARED_STATE_SET = "sharedStateSet", E.NAVIGATE_URL = "navigateUrl", E.UPDATE_QUERY_PARAMS = "updateQueryParams", E.REQUEST_WHATS_NEW_DATA =
"requestWhatsNewData", E.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", E.SET_WHATS_NEW_CACHE = "setWhatsNewCache", E.TOGGLE_WHATS_NEW_NOTIFICATIONS =
"toggleWhatsNewNotifications", E.TELEMETRY_ERROR = "telemetryError", E.FILE_COMPONENT_SEARCH_REQUEST = "fileComponentSearchRequest", E.FILE_COMPONENT_SEARCH_RESPONSE =
"fileComponentSearchResponse", E.SAVE_STORY_REQUEST = "saveStoryRequest", E.SAVE_STORY_RESPONSE = "saveStoryResponse", E.ARGTYPES_INFO_REQUEST =
"argtypesInfoRequest", E.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse", E.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", E.CREATE_NEW_STORYFILE_RESPONSE =
"createNewStoryfileResponse", E))(R || {}), S = R, {
  CHANNEL_WS_DISCONNECT: _,
  CHANNEL_CREATED: T,
  CONFIG_ERROR: A,
  CREATE_NEW_STORYFILE_REQUEST: O,
  CREATE_NEW_STORYFILE_RESPONSE: N,
  CURRENT_STORY_WAS_SET: r,
  DOCS_PREPARED: D,
  DOCS_RENDERED: I,
  FILE_COMPONENT_SEARCH_REQUEST: C,
  FILE_COMPONENT_SEARCH_RESPONSE: o,
  FORCE_RE_RENDER: P,
  FORCE_REMOUNT: L,
  GLOBALS_UPDATED: a,
  NAVIGATE_URL: Y,
  PLAY_FUNCTION_THREW_EXCEPTION: U,
  UNHANDLED_ERRORS_WHILE_PLAYING: G,
  PRELOAD_ENTRIES: W,
  PREVIEW_BUILDER_PROGRESS: H,
  PREVIEW_KEYDOWN: d,
  REGISTER_SUBSCRIPTION: p,
  RESET_STORY_ARGS: t,
  SELECT_STORY: i,
  SET_CONFIG: l,
  SET_CURRENT_STORY: e,
  SET_GLOBALS: y,
  SET_INDEX: F,
  SET_STORIES: c,
  SHARED_STATE_CHANGED: h,
  SHARED_STATE_SET: f,
  STORIES_COLLAPSE_ALL: g,
  STORIES_EXPAND_ALL: u,
  STORY_ARGS_UPDATED: s,
  STORY_CHANGED: x,
  STORY_ERRORED: M,
  STORY_INDEX_INVALIDATED: Q,
  STORY_MISSING: m,
  STORY_PREPARED: V,
  STORY_RENDER_PHASE_CHANGED: w,
  STORY_RENDERED: B,
  STORY_SPECIFIED: X,
  STORY_THREW_EXCEPTION: b,
  STORY_UNCHANGED: q,
  UPDATE_GLOBALS: K,
  UPDATE_QUERY_PARAMS: j,
  UPDATE_STORY_ARGS: k,
  REQUEST_WHATS_NEW_DATA: z,
  RESULT_WHATS_NEW_DATA: J,
  SET_WHATS_NEW_CACHE: Z,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: $,
  TELEMETRY_ERROR: n,
  SAVE_STORY_REQUEST: v,
  SAVE_STORY_RESPONSE: EE,
  ARGTYPES_INFO_REQUEST: RE,
  ARGTYPES_INFO_RESPONSE: SE
} = R;
export {
  RE as ARGTYPES_INFO_REQUEST,
  SE as ARGTYPES_INFO_RESPONSE,
  T as CHANNEL_CREATED,
  _ as CHANNEL_WS_DISCONNECT,
  A as CONFIG_ERROR,
  O as CREATE_NEW_STORYFILE_REQUEST,
  N as CREATE_NEW_STORYFILE_RESPONSE,
  r as CURRENT_STORY_WAS_SET,
  D as DOCS_PREPARED,
  I as DOCS_RENDERED,
  C as FILE_COMPONENT_SEARCH_REQUEST,
  o as FILE_COMPONENT_SEARCH_RESPONSE,
  L as FORCE_REMOUNT,
  P as FORCE_RE_RENDER,
  a as GLOBALS_UPDATED,
  Y as NAVIGATE_URL,
  U as PLAY_FUNCTION_THREW_EXCEPTION,
  W as PRELOAD_ENTRIES,
  H as PREVIEW_BUILDER_PROGRESS,
  d as PREVIEW_KEYDOWN,
  p as REGISTER_SUBSCRIPTION,
  z as REQUEST_WHATS_NEW_DATA,
  t as RESET_STORY_ARGS,
  J as RESULT_WHATS_NEW_DATA,
  v as SAVE_STORY_REQUEST,
  EE as SAVE_STORY_RESPONSE,
  i as SELECT_STORY,
  l as SET_CONFIG,
  e as SET_CURRENT_STORY,
  y as SET_GLOBALS,
  F as SET_INDEX,
  c as SET_STORIES,
  Z as SET_WHATS_NEW_CACHE,
  h as SHARED_STATE_CHANGED,
  f as SHARED_STATE_SET,
  g as STORIES_COLLAPSE_ALL,
  u as STORIES_EXPAND_ALL,
  s as STORY_ARGS_UPDATED,
  x as STORY_CHANGED,
  M as STORY_ERRORED,
  Q as STORY_INDEX_INVALIDATED,
  m as STORY_MISSING,
  V as STORY_PREPARED,
  B as STORY_RENDERED,
  w as STORY_RENDER_PHASE_CHANGED,
  X as STORY_SPECIFIED,
  b as STORY_THREW_EXCEPTION,
  q as STORY_UNCHANGED,
  n as TELEMETRY_ERROR,
  $ as TOGGLE_WHATS_NEW_NOTIFICATIONS,
  G as UNHANDLED_ERRORS_WHILE_PLAYING,
  K as UPDATE_GLOBALS,
  j as UPDATE_QUERY_PARAMS,
  k as UPDATE_STORY_ARGS,
  S as default
};
